export default "__VITE_ASSET__Be11$zCQ__"